import React, { useMemo } from "react";
import cx from "classnames";
import { nonNumberHeaders } from "./util";
import { Link } from "react-router-dom";
import { isNumericString } from "services/util";

export const LinkCells = ({ children, link }) => {
  const linkStyle = {
    color: "#72B566",
    textDecoration: 'none', 
    transition: 'color 0.2s ease',
  };

  const hoverStyle = {
    color: 'grey', 
  };

  return (
    <Link to={link || "/bank/bank_accounts"} style={linkStyle} onMouseEnter={(e) => e.target.style.color = hoverStyle.color} onMouseLeave={(e) => e.target.style.color = linkStyle.color}>
      {children}
    </Link>
  );
};

const renderValue = (value, isNullValue, isSecondLast, isLastCell, isCalculationCorrect = true) => {
  if (!value.Value || isNullValue) return "-";
  
  const className = (isSecondLast || isLastCell) && isCalculationCorrect === false ? "text-danger-dark" : "";
  
  return isSecondLast ? (
    <LinkCells><span className={className}>{value.Value}</span></LinkCells>
  ) : (
    <span className={className}>{value.Value}</span>
  );
};

const ReportCell = ({ value, index, rowType, header, isLastCell, isSecondLast, isCalculationCorrect }) => {
  const nonNumberHeader = nonNumberHeaders[header?.Value] || !index;
  const isNullValue = value?.Value === "0.00" 

  if (rowType === "Header") {
    return (
      <th className={!nonNumberHeader ? "text-center" : "text-left"}>{value.Value}</th>
    );
  } else {
    return (
      <td
        className={cx(
          rowType === "SummaryRow" ? "font-weight-bold" : "",
          !nonNumberHeader ? "text-center" : "",
          "text-left"
        )}
        style={{
          fontSize: "0.8rem", lineHeight: "1.0rem",

        }}
      >
        { renderValue(value, isNullValue, isSecondLast, isLastCell, isCalculationCorrect) }
    </td>
    );
  }
};

const ReportRow = ({ value, headers }) => {
  const { RowType, Cells, Title, Rows } = value;

  if (RowType === "Header") {
    return (
      <tr className="table-info">
        {Cells.map((i, idx) => (
          <ReportCell
            index={idx}
            value={i}
            rowType={RowType}
            key={idx}
            header={headers[idx]}
          />
        ))}
      </tr>
    );
  } else if (RowType === "Row" || RowType === "SummaryRow") { 
    
    let endingCredit = Cells.pop()?.Value
    let endingDebit = Cells.pop()?.Value
    let calculatedEndingDebit = Cells[Cells.length - 2]?.Value
    let calculatedEndingCredit = Cells[Cells.length - 1]?.Value

    let isCalculationCorrect = endingCredit === calculatedEndingCredit && endingDebit === calculatedEndingDebit

    return (
      <tr>
        {Cells.map((i, idx) => (
          <ReportCell
            index={idx}
            value={i}
            rowType={RowType}
            key={idx}
            header={headers[idx]}
            isSecondLast={idx === Cells.length - 2}
            isLastCell={idx === Cells.length - 1}
            isCalculationCorrect={isCalculationCorrect}
          />
        ))}
      </tr>
    );
  } else if (RowType === "Section") {
    return (
      <>
        {Title ? (
          <tr>
            <td colSpan={headers.length} className="text-left" style={{ fontWeight: "bold", fontSize: "1.1rem" }}>
              {Title}
            </td>
          </tr>
        ) : null}
        {Rows?.map((i, idx) => (
          <ReportRow key={idx} value={i} headers={headers} />
        ))}
      </>
    );
  } else if (RowType === "BigHead") {
    return (
      <tr>
        <td
          colSpan={headers.length}
          style={{ fontWeight: "bold", lineHeight: "1.75rem" }}
        >
          {Title}
        </td>
        {Rows?.map((i, idx) => (
          <ReportRow key={idx} value={i} headers={headers} />
        ))}
      </tr>
    );
  } else {
    return null;
  }
};

export const ReportRows = ({ rows }) => {
  if (!rows.length) return null;
  const [header, ...rest] = rows;
  const headers = header.Cells;

  const newHeader = { Value: 'Code', NonNumber: true };
  headers.splice(1, 0, newHeader);

  const dashItem = { Value: '-' };

  rest.forEach((item, index, array) => {
    const cells = item.Cells;
    
    if (cells.length > 1) {
      const valueParts = cells[0].Value.split(' ');
      const lastPart = valueParts.length > 1 && valueParts[valueParts.length - 1].startsWith('(')
        ? valueParts.pop()
        : '';
      
      const remainingPart = valueParts.join(' ');
      const accountCode = lastPart ? lastPart : '-';
      // const accountCode = lastPart !== '' ? <LinkCells link="/accounts/chart_of_accounts/all">{lastPart}</LinkCells> : '-';
      
      const lastPartItem = { Value: accountCode, NonNumber: true };
      const remainingPartItem = { Value: remainingPart, NonNumber: true };
    
      cells.splice(0, 1, index === array.length - 1 ? dashItem : lastPartItem);
      cells.unshift(remainingPartItem); 
    }
    
  });

  return (
    <>
      <ReportRow value={header} headers={headers} />
      {rest.map((i, idx) => (
        <ReportRow value={i} key={idx} headers={headers} />
      ))}
    </>
  );
};
